import { store } from '../../../../../resources/frontend/js/store';
import {disableButton} from './buttons';
import {fillLinkedFormInput} from '../../form/linked-form-input';
import {goToQuestion} from './go-to-question';

export const checkCompleted = (name, buttons, preHook, question, afterHook, answerValue, linkedFormInputIdentifier, worktypeId, enquiryDashboardRedirectVersion, delay) => {
    for (const button of buttons) {
        disableButton(button);
    }

    storeAnswer(name, answerValue);
    fillReplaceableQuestionVariables(answerValue);
    fillLinkedFormInput(linkedFormInputIdentifier, answerValue);
    fillWorktypeId(worktypeId);
    fillEnquiryDashboardRedirectVersion(enquiryDashboardRedirectVersion);

    setTimeout(() => {
        goToQuestion(preHook, question, afterHook);
    }, delay);
};

export const storeAnswer = (name, value) => {
    const questionNumber = store.state.quiz.currentQuestion;
    const question = store.state.quiz.questionsData[questionNumber - 1];

    store.commit('form/setFieldData', { name, key: 'value', value: value });
    store.commit('quiz/storeAnswer', {
        key: question._info.uuid || questionNumber,
        value: value.toString(),
    });
};

export const fillReplaceableQuestionVariables = value => {
    const questionNumber = store.state.quiz.currentQuestion;
    const question = store.state.quiz.questionsData[questionNumber - 1];

    store.commit('page/setVariable', {
        key: `question-${store.state.quiz.currentQuestion}`,
        value: value,
    });

    store.commit('page/setVariable', {
        key: `question_id-${question._info.uuid}`,
        value: value,
    });
};

export const fillWorktypeId = worktypeId => {
    if(!worktypeId) return;

    if(!store.getters['form/fieldExists']('worktype_id')) {
        store.commit('form/addField', {
            step: 0,
            name: 'worktype_id',
        });
    }

    store.commit('form/setFieldData', {
        name: 'worktype_id',
        key: 'value',
        value: worktypeId,
    });
};

export const fillEnquiryDashboardRedirectVersion = enquiryDashboardRedirectVersion => {
    if(!enquiryDashboardRedirectVersion) return;

    if(!store.getters['form/fieldExists']('enquiry_dashboard_redirect_version')) {
        store.commit('form/addField', {
            step: 0,
            name: 'enquiry_dashboard_redirect_version',
        });
    }

    store.commit('form/setFieldData', {
        name: 'enquiry_dashboard_redirect_version',
        key: 'value',
        value: enquiryDashboardRedirectVersion,
    });
};
